import { defineStore } from "pinia";
import { ref } from "vue";

export const useThemeStore = defineStore("theme", () => {
  const currentTheme = ref(localStorage.getItem("theme") || "light");

  function applyThemeClass(theme) {
    if (theme === "light") {
      document.documentElement.classList.remove("tw-dark");
    } else {
      document.documentElement.classList.add("tw-dark");
    }
  }

  function switchTheme() {
    currentTheme.value = currentTheme.value === "dark" ? "light" : "dark";
    localStorage.setItem("theme", currentTheme.value);
    applyThemeClass(currentTheme.value);
  }

  // Apply on init
  applyThemeClass(currentTheme.value);

  return { currentTheme, switchTheme };
});
